var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "lab-search bg-primary-light p-3 mt-3",
        class: {
          "d-flex align-items-center justify-content-center": "!initialloading"
        }
      },
      [
        _vm.initialloading
          ? _c("div", { staticClass: "spinner-wrapper mx-auto" }, [_vm._m(0)])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "form",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.initialloading,
                expression: "!initialloading"
              }
            ],
            on: {
              submit: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-6" }, [
                _c("fieldset", [
                  _c("legend", { staticClass: "fw-bold fs-6 mb-0 mt-n1" }, [
                    _vm._v("Group by")
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      staticClass:
                        "list-unstyled d-flex align-items-center gap-3"
                    },
                    [
                      _c("li", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filters.groupedBy,
                              expression: "filters.groupedBy"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            id: "intervention",
                            value: "intervention"
                          },
                          domProps: {
                            checked: _vm._q(
                              _vm.filters.groupedBy,
                              "intervention"
                            )
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.filters,
                                "groupedBy",
                                "intervention"
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "fs-8 text-dark",
                            attrs: { for: "intervention" }
                          },
                          [_vm._v("Intervention")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filters.groupedBy,
                              expression: "filters.groupedBy"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            id: "local_example",
                            value: "local_example"
                          },
                          domProps: {
                            checked: _vm._q(
                              _vm.filters.groupedBy,
                              "local_example"
                            )
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.filters,
                                "groupedBy",
                                "local_example"
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "fs-8 text-dark",
                            attrs: { for: "local_example" }
                          },
                          [_vm._v("Local Example")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filters.groupedBy,
                              expression: "filters.groupedBy"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            id: "innovator_counties",
                            value: "innovator_counties"
                          },
                          domProps: {
                            checked: _vm._q(
                              _vm.filters.groupedBy,
                              "innovator_counties"
                            )
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.filters,
                                "groupedBy",
                                "innovator_counties"
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "fs-8 text-dark",
                            attrs: { for: "innovator_counties" }
                          },
                          [_vm._v("Innovator Counties")]
                        )
                      ])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-6" }, [
                _c("fieldset", [
                  _c("legend", { staticClass: "fw-bold fs-6 mb-0 mt-lg-n1" }, [
                    _vm._v("Type")
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "list-unstyled col2" },
                    _vm._l(_vm.types, function(t) {
                      return _c("li", { staticClass: "fs-8 text-dark" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filters.types,
                              expression: "filters.types"
                            }
                          ],
                          attrs: { type: "checkbox", id: t.id },
                          domProps: {
                            value: t.id,
                            checked: Array.isArray(_vm.filters.types)
                              ? _vm._i(_vm.filters.types, t.id) > -1
                              : _vm.filters.types
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.filters.types,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = t.id,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.filters,
                                      "types",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.filters,
                                      "types",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.filters, "types", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", {
                          staticClass: "d-block",
                          attrs: { for: t.id },
                          domProps: { innerHTML: _vm._s(t.name) }
                        })
                      ])
                    }),
                    0
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-6" }, [
                _c("fieldset", [
                  _c("legend", { staticClass: "fw-bold fs-6 mb-0" }, [
                    _vm._v("Measure")
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "list-unstyled col2" },
                    _vm._l(_vm.measures, function(measure) {
                      return _c("li", { staticClass: "fs-8 text-dark" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filters.measures,
                              expression: "filters.measures"
                            }
                          ],
                          attrs: { type: "checkbox", id: measure.id },
                          domProps: {
                            value: measure.id,
                            checked: Array.isArray(_vm.filters.measures)
                              ? _vm._i(_vm.filters.measures, measure.id) > -1
                              : _vm.filters.measures
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.filters.measures,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = measure.id,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.filters,
                                      "measures",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.filters,
                                      "measures",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.filters, "measures", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "d-block",
                            attrs: { for: measure.id }
                          },
                          [_vm._v(_vm._s(measure.name))]
                        )
                      ])
                    }),
                    0
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-6" }, [
                _c("fieldset", [
                  _c("legend", { staticClass: "fw-bold fs-6 mb-0" }, [
                    _vm._v("Category")
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "list-unstyled col2" },
                    _vm._l(_vm.categories, function(category) {
                      return _c("li", { staticClass: "fs-8 text-dark" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filters.categories,
                              expression: "filters.categories"
                            }
                          ],
                          attrs: { type: "checkbox", id: category.id },
                          domProps: {
                            value: category.id,
                            checked: Array.isArray(_vm.filters.categories)
                              ? _vm._i(_vm.filters.categories, category.id) > -1
                              : _vm.filters.categories
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.filters.categories,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = category.id,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.filters,
                                      "categories",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.filters,
                                      "categories",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.filters, "categories", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "d-block",
                            attrs: { for: category.id }
                          },
                          [_vm._v(_vm._s(category.name))]
                        )
                      ])
                    }),
                    0
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-lg-6" },
                [
                  _c("label", { staticClass: "fw-bold fs-6" }, [
                    _vm._v("Local examples")
                  ]),
                  _vm._v(" "),
                  _c("multiselect", {
                    attrs: {
                      options: _vm.local_examples.map(function(local_example) {
                        return local_example.id
                      }),
                      multiple: true,
                      disabled: _vm.initialloading,
                      "close-on-select": false,
                      "clear-on-select": false,
                      "preserve-search": true,
                      placeholder: "Pick one or more",
                      "custom-label": function(opt) {
                        return _vm.local_examples.find(function(x) {
                          return x.id == opt
                        }).name
                      },
                      id: "local-examples",
                      "preselect-first": false
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "selection",
                        fn: function(ref) {
                          var values = ref.values
                          var search = ref.search
                          var isOpen = ref.isOpen
                          return [
                            values.length && !isOpen
                              ? _c(
                                  "span",
                                  { staticClass: "multiselect__single" },
                                  [
                                    _vm._v(
                                      _vm._s(values.length) +
                                        " options selected"
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.filters.local_examples,
                      callback: function($$v) {
                        _vm.$set(_vm.filters, "local_examples", $$v)
                      },
                      expression: "filters.local_examples"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-lg-6" },
                [
                  _c("label", { staticClass: "fw-bold fs-6" }, [
                    _vm._v("Intervention")
                  ]),
                  _vm._v(" "),
                  _c("multiselect", {
                    attrs: {
                      options: _vm.entries.map(function(entry) {
                        return entry.id
                      }),
                      multiple: true,
                      disabled: _vm.initialloading,
                      "close-on-select": false,
                      "clear-on-select": false,
                      "preserve-search": true,
                      placeholder: "Pick one or more",
                      "custom-label": function(opt) {
                        return _vm.entries.find(function(x) {
                          return x.id == opt
                        }).title
                      },
                      id: "interventions",
                      "preselect-first": false
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "selection",
                        fn: function(ref) {
                          var values = ref.values
                          var search = ref.search
                          var isOpen = ref.isOpen
                          return [
                            values.length && !isOpen
                              ? _c(
                                  "span",
                                  { staticClass: "multiselect__single" },
                                  [
                                    _vm._v(
                                      _vm._s(values.length) +
                                        " options selected"
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.filters.interventions,
                      callback: function($$v) {
                        _vm.$set(_vm.filters, "interventions", $$v)
                      },
                      expression: "filters.interventions"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row align-items-center mt-4" }, [
              _c("div", { staticClass: "col-lg-6" }, [
                _c("p", { staticClass: "fw-bold fs-6 mb-lg-0" }, [
                  _vm._v("Results: " + _vm._s(_vm.resultsLength))
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-lg-6 d-lg-flex align-items-center justify-content-end"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-red btn-sm mb-3 mb-lg-0 me-2",
                      on: { click: _vm.apply }
                    },
                    [_vm._v("Apply")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-light btn-sm mb-lg-0 mb-3",
                      on: { click: _vm.reset }
                    },
                    [_vm._v("Reset")]
                  )
                ]
              )
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-4" }, [
      _c("div", { staticClass: "col-lg-6" }, [
        _c("form", { attrs: { method: "post", action: _vm.adminPost } }, [
          _c("input", {
            attrs: { type: "hidden", name: "action", value: "export" }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "frontend_nonce" },
            domProps: { value: _vm.nonce }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "data" },
            domProps: { value: JSON.stringify(_vm.displayedEntries) }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "exporttype" },
            domProps: { value: _vm.groupedBy }
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-sm rounded-0 px-4 btn-secondary text-dark",
              attrs: { type: "submit", disabled: _vm.initialloading }
            },
            [_vm._v("Export Results")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.groupedBy === "intervention"
        ? _c(
            "div",
            {
              staticClass:
                "col-lg-6 d-flex align-items-center justify-content-end"
            },
            [
              _c("p", { staticClass: "fw-bold fs-6 me-3" }, [_vm._v("Show:")]),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass: "list-unstyled d-flex align-items-center gap-3"
                },
                [
                  _c("li", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filters.show,
                          expression: "filters.show"
                        }
                      ],
                      attrs: {
                        type: "radio",
                        id: "show_intervention",
                        value: "intervention",
                        disabled: _vm.initialloading
                      },
                      domProps: {
                        checked: _vm._q(_vm.filters.show, "intervention")
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.filters, "show", "intervention")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "fs-8 text-dark",
                        attrs: { for: "show_intervention" }
                      },
                      [_vm._v("Intervention")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filters.show,
                          expression: "filters.show"
                        }
                      ],
                      attrs: {
                        type: "radio",
                        id: "show_local_example",
                        value: "local_example",
                        disabled: _vm.initialloading
                      },
                      domProps: {
                        checked: _vm._q(_vm.filters.show, "local_example")
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.filters, "show", "local_example")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "fs-8 text-dark",
                        attrs: { for: "show_local_example" }
                      },
                      [_vm._v("Local Example")]
                    )
                  ])
                ]
              )
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "section",
      [
        _vm._l(10, function(i) {
          return _vm.initialloading
            ? _c("div", { staticClass: "bg-light mt-4 p-4 mb-4" }, [
                _c("h5", {
                  staticClass:
                    "d-block skeleton-loader skeleton-h5 bg-gray-400 w-50"
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "d-block skeleton-loader skelton-description mb-3 bg-gray-400 w-100"
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "d-block skeleton-loader skelton-terms bg-gray-400 w-50"
                })
              ])
            : _vm._e()
        }),
        _vm._v(" "),
        _vm.groupedBy === "intervention" && _vm.loading == false
          ? _c(
              "div",
              _vm._l(
                _vm.displayedEntries.slice(
                  _vm.currentPage * 10 - 10,
                  _vm.currentPage * 10
                ),
                function(intervention, key) {
                  return _c(
                    "div",
                    { key: key, staticClass: "bg-light mt-4 p-4 mb-4" },
                    [
                      _c("h5", [
                        _c(
                          "a",
                          {
                            staticClass: "text-primary-medium border-0",
                            attrs: {
                              href:
                                _vm.siteURL +
                                "/resource_lab/" +
                                intervention.slug
                            }
                          },
                          [_vm._v(_vm._s(intervention.title))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fs-6 entry-excerpt mb-n2",
                        domProps: {
                          innerHTML: _vm._s(intervention.post_excerpt)
                        }
                      }),
                      _vm._v(" "),
                      _vm.filters.show == "intervention"
                        ? _c("div", [
                            _c("div", { staticClass: "d-flex gap-2 fs-8" }, [
                              _vm._m(1, true),
                              _vm._v(" "),
                              _c(
                                "ul",
                                {
                                  staticClass: "mb-0 list-unstyled d-flex gap-4"
                                },
                                _vm._l(intervention.typestax, function(
                                  type,
                                  index
                                ) {
                                  return _c("li", {
                                    key: index,
                                    domProps: { innerHTML: _vm._s(type.name) }
                                  })
                                }),
                                0
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "d-flex gap-2 fs-8" }, [
                              _vm._m(2, true),
                              _vm._v(" "),
                              _c(
                                "ul",
                                {
                                  staticClass: "mb-0 list-unstyled d-flex gap-4"
                                },
                                _vm._l(intervention.measures, function(
                                  measure,
                                  index
                                ) {
                                  return _c("li", {
                                    key: index,
                                    domProps: {
                                      innerHTML: _vm._s(measure.name)
                                    }
                                  })
                                }),
                                0
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "d-flex gap-2 fs-8" }, [
                              _vm._m(3, true),
                              _vm._v(" "),
                              _c(
                                "ul",
                                {
                                  staticClass: "mb-0 list-unstyled d-flex gap-4"
                                },
                                _vm._l(intervention.categories, function(
                                  c,
                                  index
                                ) {
                                  return _c("li", {
                                    key: index,
                                    domProps: { innerHTML: _vm._s(c.name) }
                                  })
                                }),
                                0
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.filters.show == "local_example"
                        ? _c("div", { staticClass: "d-flex gap-2 fs-8" }, [
                            _c(
                              "ul",
                              { staticClass: "mt-2 mb-0 list-unstyled" },
                              _vm._l(intervention.local_example, function(
                                example,
                                index
                              ) {
                                return _c("li", {
                                  key: index,
                                  staticClass: "mb-2",
                                  domProps: { innerHTML: _vm._s(example.name) }
                                })
                              }),
                              0
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                }
              ),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        (_vm.groupedBy === "local_example" ||
          _vm.groupedBy === "innovator_counties") &&
        _vm.loading == false
          ? _c(
              "div",
              _vm._l(
                _vm.displayedEntries.slice(
                  _vm.currentPage * 10 - 10,
                  _vm.currentPage * 10
                ),
                function(local_example, key) {
                  return _c(
                    "div",
                    { key: key, staticClass: "bg-light mt-4 p-4 mb-4" },
                    [
                      _c("h5", { staticClass: "mb-2" }, [
                        _vm._v(_vm._s(local_example.name))
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "list-unstyled fs-8" },
                        _vm._l(local_example.entries, function(example) {
                          return _c(
                            "li",
                            { key: example.id, staticClass: "mb-2" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "text-primary-medium border-0",
                                  attrs: {
                                    href:
                                      _vm.siteURL +
                                      "/resource_lab/" +
                                      example.slug
                                  }
                                },
                                [_vm._v(_vm._s(example.title))]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                }
              ),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.loading && _vm.totalPages > 1
          ? _c("nav", { attrs: { "aria-label": "Page navigation" } }, [
              _c(
                "ul",
                { staticClass: "pagination" },
                [
                  _c(
                    "li",
                    {
                      staticClass: "page-item",
                      class: { disabled: !_vm.hasPreviousPage }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "page-link",
                          attrs: {
                            tabindex: "-1",
                            "aria-disabled": !_vm.hasPreviousPage
                          },
                          on: {
                            click: function($event) {
                              return _vm.changePage("prev")
                            }
                          }
                        },
                        [_vm._v("Previous")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.totalPages, function(t, index) {
                    return _c(
                      "li",
                      {
                        key: index + 1,
                        staticClass: "page-item",
                        class: { active: index + 1 == _vm.currentPage },
                        on: {
                          click: function($event) {
                            return _vm.changePage(index + 1)
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "page-link" }, [
                          _vm._v(_vm._s(index + 1))
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "page-item",
                      class: { disabled: !_vm.hasNextPage }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "page-link",
                          attrs: { "aria-disabled": !_vm.hasNextPage },
                          on: {
                            click: function($event) {
                              return _vm.changePage("next")
                            }
                          }
                        },
                        [_vm._v("Next")]
                      )
                    ]
                  )
                ],
                2
              )
            ])
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "spinner-border d-block", attrs: { role: "status" } },
      [_c("span", { staticClass: "visually-hidden" }, [_vm._v("Loading...")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "mb-0" }, [
      _c("strong", { staticClass: "fw-bold text-dark" }, [_vm._v("Type")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "mb-0" }, [
      _c("strong", { staticClass: "fw-bold text-dark" }, [_vm._v("Measures")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "mb-0" }, [
      _c("strong", { staticClass: "fw-bold text-dark" }, [_vm._v("Categories")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }